import React, { useState } from 'react';
import SpinSphereIcon from './SpinSphereIcon';

const Header = ({ isDark, setIsDark }) => {
  const [spinKey, setSpinKey] = useState(0);

  const handleClick = () => {
    setIsDark(!isDark);
    setSpinKey((k) => k + 1);
  };

  return (
    <button
      className="theme-toggle"
      onClick={handleClick}
      aria-label="Toggle dark mode"
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <SpinSphereIcon spinKey={spinKey} />
    </button>
  );
};

export default Header;
